import { IonButton, IonCol, IonIcon, IonRow, IonText, useIonToast } from '@ionic/react';
import { downloadOutline } from 'ionicons/icons';
import { AuthContext } from '../../context/AuthContext';
import './DownloadDoc.css'

interface Props {
    id: any;
    title: string,
    small?: boolean
}

const DownloadDoc: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();
    const showDocGuestMessageHandler = () => {
        toast({ message: "جهت دریافت مجدد سند یا پلاک نهال های اهدا شده خود، ثبت نام کرده و یا وارد حساب کاربری خود شوید.", duration: 6000, color: "warning" })
    }

    return (
        <AuthContext.Consumer>
            {
                (context) => {
                    return <>
                        {context.auth ?
                        <IonButton className={'campaign-doc-download' + (props.small ? " campaign-doc-download-small" : "")} expand='block' color="danger" routerLink={`/campaign/${props.id}/tree-doc`}>
                            {(props.small == null || !props.small) ? <><IonIcon slot='start' src={downloadOutline} /> دریافت سند/پلاک</> : <>سند/پلاک</>}
                        </IonButton> :
                        <IonButton className={'campaign-doc-download'  + (props.small ? " campaign-doc-download-small" : "")} expand='block' color="danger" onClick={showDocGuestMessageHandler}>
                            {(props.small == null || !props.small) ? <><IonIcon slot='start' src={downloadOutline} /> دریافت سند/پلاک</> : <>سند/پلاک</>}
                        </IonButton>}
                    </>
                }
            }
        </AuthContext.Consumer>
    );
};

export default DownloadDoc;
